import { render, staticRenderFns } from "./authentification.vue?vue&type=template&id=53515490&scoped=true&"
import script from "./authentification.vue?vue&type=script&lang=js&"
export * from "./authentification.vue?vue&type=script&lang=js&"
import style0 from "./authentification.vue?vue&type=style&index=0&id=53515490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53515490",
  null
  
)

export default component.exports